import angular from 'angular';

/**
* Factory: AccountType
* 
* Constant factory that contains AccountType types.
*
* TODO: Deprecated. Use 'SERVER.AccountTypes'.
**/
export default angular
  .module('books.data.AccountType', [])
  /* @ngInject */
  .factory('AccountType', function (SERVER) {
    return SERVER.AccountTypes;
  })
  .name;
